import { writable } from 'svelte/store';
import en from './edited/en';
const flattenInto = (tree, prefix, result) => {
    for (const [key, value] of Object.entries(tree)) {
        const flatKey = prefix ? `${prefix}.${key}` : key;
        if (typeof value === 'object')
            flattenInto(value, flatKey, result);
        else
            result[flatKey] = value;
    }
};
/** Flattens `{ page: { key: text } }` into `{ 'page.key': text }`. */
export const flattenTranslations = (tree) => {
    const result = {};
    flattenInto(tree, '', result);
    return result;
};
const englishTranslations = flattenTranslations(en);
export const translations = writable(englishTranslations);
// Async loader for each language
const asyncTranslations = {
    cs: () => import('./edited/cs'),
    id: () => import('./edited/id'),
    ar: () => import('./edited/ar'),
    vi: () => import('./edited/vi'),
    ms: () => import('./edited/ms'),
    no: () => import('./edited/no'),
    de: () => import('./edited/de'),
    es: () => import('./edited/es'),
    fi: () => import('./edited/fi'),
    fr: () => import('./edited/fr'),
    it: () => import('./edited/it'),
    ja: () => import('./edited/ja'),
    ko: () => import('./edited/ko'),
    pt: () => import('./edited/pt'),
    ru: () => import('./edited/ru'),
    tr: () => import('./edited/tr'),
    th: () => import('./edited/th'),
    uk: () => import('./edited/uk'),
    zh: () => import('./edited/zh')
};
export async function loadTranslation(lang) {
    if (lang === 'en') {
        translations.set(englishTranslations);
        return;
    }
    try {
        const module = await asyncTranslations[lang]();
        translations.set(flattenTranslations(module.default));
    }
    catch (error) {
        console.warn(`Failed to load translations for ${lang}`, error);
        // Fallback to English if load fails
        translations.set(englishTranslations);
    }
}
